<template>
    <div id="app">
        <v-slide-x-transition>
        <v-card v-if="showSelectionOptions" flat id="main-selection-container">
            <div class="main-selection-div">
                <v-card @click="openHelpSection(1)" dark ripple class="card-area">
                    <div class="selection-icon">
                        <v-icon style="font-size: 20vh">far fa-clone</v-icon>
                    </div>
                    <div class="selection-text">
                        Quick Copy
                    </div>
                </v-card>
            </div>
            <div class="main-selection-div">
                <v-card @click="openHelpSection(2)" dark ripple class="card-area">
                    <div class="selection-icon">
                        <v-icon style="font-size: 20vh">fas fa-th-list</v-icon>
                    </div>
                    <div class="selection-text">
                        Order Status
                    </div>
                </v-card>
            </div>
        </v-card>
        </v-slide-x-transition>

        <v-card v-if="showSelectionOptions == false" id="help-content">
            <app-quick-copy v-if="openSection == 1" style="width: 100%; height: 100%"
                            @pageCloseTrigger="showSelectionOptions = $event"
            ></app-quick-copy>

            <app-status v-if="openSection == 2" style="width: 100%; height: 100%"
                        @pageCloseTrigger="showSelectionOptions = $event"
            ></app-status>
        </v-card>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { AXIOS } from '../../http-common'
import VueApexCharts from 'vue-apexcharts'
import QuickCopyHelp from '@/components/help/help-copy/help-copy.vue'
import StatusHelp from '@/components/help/help-status/help-status.vue'
import AnnouncementHelp from '@/components/help/help-annoucements/help-announcement.vue'

Vue.use(Vuetify)
Vue.use(VueApexCharts)
export default {

  components: {
    apexcharts: VueApexCharts,
      appQuickCopy: QuickCopyHelp,
      appStatus: StatusHelp,
      appAnnouncements: AnnouncementHelp
  },

  data () {
    return {
        openSection: 0,
        showSelectionOptions: true,
    }
  },
  watch: {},
  created: function () {
    document.title = 'Chattube - Help'
  },
  computed: {},
  methods: {
      openHelpSection(i){
          this.showSelectionOptions = false
          if (i == 1){
              this.openSection = 1
          }
          else if (i == 2){
              this.openSection = 2
          }
          else if (i == 3){
              this.openSection = 3
          }
      }
  }
}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;
        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        padding: 1%;
    }
    .main-selection-div {
        width: 33.3%; height: 100%; float: left;
        display: flex; justify-content: center; align-items: center;
    }
    .selection-icon {
        width: 100%; height: 60%; display: flex; justify-content: center; align-items: center
    }
    .selection-text {
        color: white;width: 100%; height: 40%; display: flex; justify-content: center; align-items: center; font-size: 5vh; font-weight: bold
    }
    .card-area {
        height: 80%;
        width: 90%;
    }
    #main-selection-container {
        width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;
        padding-left: 5%;
        padding-right: 5%;
    }
    #help-content {
        width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;
        padding-left: 5%;
        padding-right: 5%;
    }
</style>